import { render } from "./NcrmMailjetPropertyMappingsTab.vue?vue&type=template&id=3711e19a"
import script from "./NcrmMailjetPropertyMappingsTab.vue?vue&type=script&lang=js"
export * from "./NcrmMailjetPropertyMappingsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__